module.exports = __webpack_public_path__ + "img/clock.a52b621b.svg";